import { buildProps, definePropType } from '@ll-plus/utils'
import { footerShadowPlacement } from '../../new-drawer'

import type { ExtractPropTypes } from 'vue'
import type Modal from './modal.vue'
import type { ButtonProps } from '@ll-plus/components'

// modal的类型 确认框和操作框
export const modalType = ['confirm', 'operate'] as const

export const newModalProps = buildProps({
  /**
   * @description 弹窗是否可见
   */
  open: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 标题
   */
  title: {
    type: String,
    default: '提示',
  },
  /**
   * @description  确认/知道了按钮loading
   */
  confirmLoading: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 取消按钮的配置信息
   */
  cancelButtonProps: {
    type: definePropType<ButtonProps>(Object),
  },
  /**
   * @description 确认按钮的配置信息
   */
  okButtonProps: {
    type: definePropType<ButtonProps>(Object),
  },
  /**
   * @description 弹窗类型 确认/操作框
   */
  type: {
    type: String,
    values: modalType,
    default: 'operate',
  },
  /**
   * @description 弹窗外层容器的类名
   */
  wrapClassName: {
    type: String,
    default: '',
  },
  /**
   * @description 滚动是否显示底部阴影
   */
  isShowFooterShadow: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 决定底部阴影的方向(外部和内部）,默认由内容区域来决定
   */
  footerShadowPlacement: {
    type: String,
    values: footerShadowPlacement,
    default: 'inner',
  },
  /**
   * @description 确认按钮文字
   */
  confirmText: {
    type: String,
    default: '',
  },
  /**
   * @description 取消按钮文字
   */
  cancelText: {
    type: String,
    default: '取消',
  },
  /**
   * @description 显示底部
   */
  showFooter: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 是否使用esc关闭
   */
  keyboard: {
    type: Boolean,
    default: true,
  },
} as const)

export const newModalEmits = {
  /**
   * @description 点击取消时触发
   */
  cancel: () => true,
  /**
   * @description 点击确认时触发
   */
  ok: () => true,
  'update:open': () => true,
} as const

// props
export type NewModalProps = ExtractPropTypes<typeof newModalProps>

// emits
export type NewModalEmits = typeof newModalEmits
export type ModalType = NewModalProps['type']

// instance
export type NewModalInstance = InstanceType<typeof Modal>
